export default __webpack_public_path__ + "static/media/flech.fc44a91f.png";